import { Controller } from "@hotwired/stimulus";

export default class BackskinController extends Controller {
  connect() {
    const sliderEl = document.querySelector("#range2");
    const sliderValue = document.querySelector(".value2");
    sliderEl.addEventListener("input", (event) => {
      const tempSliderValue = event.target.value;
      const currencyValue = Number.parseInt(tempSliderValue).toLocaleString(
        "en-US",
        {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0
        }
      );
      sliderValue.textContent = currencyValue + "/ 10 sec";
      const progress = (tempSliderValue / sliderEl.max) * 100;
      sliderEl.style.background = `linear-gradient(to right, #E85BF4 ${progress}%, #1EC92F ${progress}%)`;
    });
  }

  changePaymentForm(e) {
    let selected_card = $(this.element)
      .find("input[type=\"radio\"]:checked")
      .attr("data-value");
    if (selected_card) {
      if (selected_card === "bank_account") {
        fetch("/user_bank_accounts/new?selected_method=" + selected_card, {
          method: "get",
          headers: {
            Accept: "text/vnd.turbo-stream.html",
            "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]")?.content || "",
            "Content-Type": "application/json"
          }
        })
          .then((r) => r.text())
          .then((html) => {
            Turbo.renderStreamMessage(html);
          });
      } else {
        Swal.fire({
          customClass: {
            popup:
              "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
            htmlContainer: "text-black-paint text-white"
          },
          animation: false,
          html: "select bank account",
          icon: "error",
          showCloseButton: true,
          buttonsStyling: false,
          showConfirmButton: false,
          timer: 3000
        });
      }
    } else {
      Swal.fire({
        customClass: {
          popup:
            "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
          htmlContainer: "text-black-paint text-white"
        },
        animation: false,
        html: "select one of this option",
        icon: "error",
        showCloseButton: true,
        buttonsStyling: false,
        showConfirmButton: false,
        timer: 3000
      });
    }
  }
}
